package fr.frux.feature.mytrees

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/** Contrat de fabrique du [MyTreesViewModel], honoré par le composition root (#43). */
fun interface MyTreesViewModelFactory {
    fun create(): MyTreesViewModel
}

/** Fabrique installée par le composition root ; sans défaut, pour que l'oubli de câblage crie. */
val LocalMyTreesViewModelFactory = staticCompositionLocalOf<MyTreesViewModelFactory> {
    error("MyTreesViewModelFactory absente : le composition root doit l'installer (cf. FruxCompositionRoot, #43)")
}

@Composable
fun rememberMyTreesViewModel(): MyTreesViewModel {
    val factory = LocalMyTreesViewModelFactory.current
    return viewModel { factory.create() }
}
